<template>
  <div class="star-new">
    <img v-if="isAvg" :src="`/static/img/ratings/${starImageName()}.png`"/>
    <ul
      v-else
      :class="[{ 'shrink': shrink }, { 'enlarge-mobile': enlargeMobile }, { 'business-widget': businessStatsWidget }, { 'reviews-widget': reviewsWidget }, { 'review-card': reviewCard }, { 'business-detail': businessDetail }, { 'industry-business' : industryBusiness}]">
      <li v-for="n in 5" :class="fillClass(n)">
        <i class="fas fa-star" :class="`${css}`" aria-hidden="true"></i>
      </li>
    </ul>
  </div>
</template>
<script>
/* eslint-env mocha
* usage <rating :stars="{Number}"></rating> where the number can range from 1 to 5
*/
export default {
  props: {
    stars: {
      type: Number,
      default: 0
    },
    isAvg: {
      type: Boolean,
      default: false
    },
    css: {
      type: String,
      default: ''
    },
    shrink: {
      type: Boolean,
      default: false
    },
    enlargeMobile: {
      type: Boolean,
      default: false
    },
    businessStatsWidget: {
      type: Boolean,
      default: false
    },
    reviewsWidget: {
      type: Boolean,
      default: false
    },
    reviewCard: {
      type: Boolean,
      default: false
    },
    businessDetail: {
      type: Boolean,
      default: false
    },
    industryBusiness: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    starImageName() {
      this.stars = Math.round(parseFloat(this.stars) * 10) / 10
      let starRating = this.stars.toString()
      starRating = starRating.split('.')
      let star = starRating[0]
      let decimal = 0
      if (starRating.length > 1) {
        decimal = starRating[1].substring(0, 1);
      }
      if (decimal >= 3 && decimal <= 7) {
        star += '_5'
      } else if (decimal >= 8) {
        ++star
      }
      return star
    },
    fillClass(index) {
      const rating = index > this.stars ? 0 : this.stars
      return `is-star-${rating}`
    },
  }
}
</script>
<style scoped lang="scss">
ul {
  list-style-type: none;
  width: 180px;
}

.shrink {
  width: 120px;
  margin-left: auto;
  margin-right: auto;
}

.shrink.enlarge-mobile {
  width: 150px;
}

li {
  display: inline;
  font-size: 1.5em;
  margin-left: 3px;
}

.business-widget {
  font-size: 1rem;
  width: 150px !important;
}

.business-widget > li:not(:first-child) {
  margin-left: 8px;
}

.reviews-widget {
  font-size: 0.6rem;
  width: 120px !important;
}

.reviews-widget > li {
  font-size: 1.2em;
  margin-left: 0;
}

.reviews-widget > li:not(:first-child) {
  margin-left: 8px;
}

.review-card {
  font-size: 0.6rem;
  width: 120px !important;
}

.industry-business {
  font-size: 0.6rem;
  width: 120px !important;
}

.review-card > li, .industry-business > li {
  font-size: 0.85rem;
  margin-left: 0;
}

.review-card > li:not(:first-child), .industry-business > li:not(:first-child) {
  margin-left: 5px;
}

.business-detail {
  font-size: 1rem;
  width: 120px !important;
}

.business-detail > li {
  font-size: 1rem;
  margin-left: 0;
}

.business-detail > li:not(:first-child) {
  margin-left: 5px;
}

$ratings: (
  0: #abacac,
  1: #f05645,
  2: #f89b58,
  3: #fbbb4e,
  4: #60c3a7,
  5: #25b888
);
@each $index, $rating in $ratings {
  .is-star-#{$index} {
    color: $rating;
  }
}

@media screen and (max-width: 768px) {
  ul {
    width: 135px;
  }

  li {
    font-size: 1.2em;
  }
}

@media screen and (max-width: 767px) {
  ul {
    width: 108px;
  }

  li {
    font-size: 1.2em;
  }
}

.star-new.avg-rating.starRating .business-detail li {
  font-size: 0.85rem;
}

.star-new.avg-rating.starRating {
  position: relative;
  top: 3px;
}

img {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/Rating.vue